import { render, staticRenderFns } from "./commerceBranchSelect.vue?vue&type=template&id=4a86a168&scoped=true&"
import script from "./commerceBranchSelect.vue?vue&type=script&lang=ts&"
export * from "./commerceBranchSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a86a168",
  null
  
)

export default component.exports